import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../../services/current.service';
import { DatasService } from '../../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-storage-box',
  templateUrl: './box.component.html',
})
export class StorageBoxComponent implements OnInit {
  boxes: any[];

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/caisson`, 'Rangements | Choix', {
      stepNumber: 2,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
    this.boxes = this.datas.storageInspiration.getBoxes(this.current.storage.inspirationId);
    if (this.boxes.length === 1) {
      this.selectBox(this.boxes[0].id);
    }
  }

  selectBox(boxId: number) {
    if (this.current.storage.boxId !== boxId) {
      this.current.storage.boxId = boxId;
    }

    this.onComplete.emit();
  }
}
